const BASE_URL = "https://admin.welcometowedding.com/api"; 

const defaultHeaders = {
  "Content-Type": "application/json",
};


const request = async (method, endpoint, data = {}, customHeaders = {}) => {
  const config = {
    method,
    headers: { ...defaultHeaders, ...customHeaders },
  };

  if (method !== "GET") {
    config.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, config);
    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || "Something went wrong");
    }

    return result;
  } catch (error) {
    console.error(`[${method}] ${endpoint} failed:`, error.message);
    throw error;
  }
};
export const apiHandler = {
  get: (endpoint, headers = {}) => request("GET", endpoint, {}, headers),
  post: (endpoint, data, headers = {}) => request("POST", endpoint, data, headers),
  put: (endpoint, data, headers = {}) => request("PUT", endpoint, data, headers),
  delete: (endpoint, data, headers = {}) => request("DELETE", endpoint, data, headers),
};
